export default __webpack_public_path__ + "static/map/img/country.197b7b7.svg";